export default __webpack_public_path__ + "static/media/73-JNF.433fa347.jpg";